import styled from 'styled-components';

import { Modal as SemanticModal } from 'semantic-ui-react';
import { Button as ButtonLayoutComponent } from '@playbookux/playbook-web-core';

export const Modal = styled(SemanticModal)`
  &.ui.modal {
    width: 600px;
  }
`;

export const Content = styled(SemanticModal.Content)`
  &&& {
    display: flex;
    align-items: center;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  justify-content: space-evenly;
`;

export const Button = styled(ButtonLayoutComponent)``;

export const InvertedButton = styled(ButtonLayoutComponent.Inverted)``;
